import { isReservationUpcoming } from './reservationDates';

const STORAGE_KEY = 'loyalty_reservation_denials_seen';

function normalizeId(id) {
  return id == null ? '' : String(id);
}

function readSeenIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = JSON.parse(raw || '[]');
    return Array.isArray(parsed) ? parsed.map(normalizeId) : [];
  } catch {
    return [];
  }
}

export function markReservationDenialSeen(reservationId) {
  const id = normalizeId(reservationId);
  if (!id) return;

  const seen = readSeenIds();
  if (seen.includes(id)) return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...seen, id]));
}

export function findUnseenDeniedReservations(reservations) {
  const seen = new Set(readSeenIds());

  return (Array.isArray(reservations) ? reservations : [])
    .filter((reservation) => {
      const id = normalizeId(reservation.id);
      if (!id || reservation.status !== 'denied') return false;
      if (seen.has(id)) return false;
      if (!isReservationUpcoming(reservation.reserved_at)) return false;
      return Boolean(reservation.denial_reason_key || reservation.denial_reason?.trim());
    })
    .sort((a, b) => new Date(b.reserved_at) - new Date(a.reserved_at));
}
